import { InlineError, Input } from 'avo-ui'
import TextEditor from 'components/commons/text-editor'
import TabToggle from 'components/commons/tab-toogle'
import { capitalize } from 'utils/utils'

export const Section = ({ aboutUsDetail, onChangeForm, onInsertImage, errorForm, name }) => {
    return (
        <TabToggle
            title={capitalize(name?.replace('_', ' '))}
            content={
                <div className={'flex flex-col space-y-5'}>
                    <div className={'flex flex-col space-y-3 w-1/2'}>
                        <div className={'font-semibold text-blue-90 required'}>Title</div>
                        <Input
                            className={'flex-1'}
                            name={'title'}
                            placeholder={'Masukkan title'}
                            value={aboutUsDetail?.[name]?.title}
                            onChange={(item) => onChangeForm(name, { [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.[name]?.title} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Description</div>
                        <div className={'flex-1 space-y-3'}>
                            <TextEditor
                                className={'!h-fit'}
                                defaultValue={aboutUsDetail?.[name]?.description || '<p></p>'}
                                onChange={(value) => onChangeForm(name, { description: value })}
                                onInsertImage={(value) => onInsertImage({ name, ...value })}
                                placeholder={'Isi uraian deskripsi'}
                                isBlogMode
                            />
                            <InlineError message={errorForm?.[name]?.description} />
                        </div>
                    </div>
                </div>
            }
        />
    )
}
